/**
 * Sends booking confirmation email to guest customers (account created during booking).
 * Email appears from the business; BookAPT promo is in the footer.
 */

import { getDownloadLinks } from '../config/appDistributionConfig';
import { WIDGET_BOOKING_API } from '../utils/widgetEmbed';

export interface GuestBookingConfirmationPayload {
  customer: {
    name: string;
    email: string;
  };
  booking: {
    id: string;
    serviceName: string;
    businessName: string;
    appointmentDate: string;
    appointmentTime: string;
    amount?: number;
    paymentMethod: string;
    businessEmail?: string;
    businessAddress?: string;
    businessPhone?: string;
  };
}

const MARKETING_PAGE_URL = 'https://bookapt.io';
const WEB_APP_URL = 'https://app.bookapt.io';
const IOS_APP_STORE_URL = 'https://apps.apple.com/us/app/bookapt/id6756637557';

class GuestBookingConfirmationEmailService {
  private readonly API_BASE_URL = __DEV__
    ? 'http://localhost:3000/api'
    : WIDGET_BOOKING_API;

  async sendBookingConfirmation(payload: GuestBookingConfirmationPayload): Promise<boolean> {
    try {
      const links = getDownloadLinks();

      console.log('📧 Sending guest booking confirmation to:', payload.customer.email);

      const response = await fetch(`${this.API_BASE_URL}/email/send-guest-booking-confirmation`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...payload,
          appStoreUrl: links.iosLink || IOS_APP_STORE_URL,
          playStoreUrl: links.androidLink || '',
          webAppUrl: WEB_APP_URL,
          marketingPageUrl: MARKETING_PAGE_URL,
          downloadMessage: links.downloadMessage,
          showDownloadLink: links.showDownloadLink,
        }),
      });

      const result = await response.json();

      if (result.success) {
        console.log('✅ Guest booking confirmation email sent');
        return true;
      }

      console.error('❌ Failed to send guest booking confirmation:', result.error);
      return false;
    } catch (error) {
      console.error('❌ Error sending guest booking confirmation email:', error);
      return false;
    }
  }
}

export const guestBookingConfirmationEmailService = new GuestBookingConfirmationEmailService();
export default guestBookingConfirmationEmailService;
